export default "__VITE_ASSET__13743f37__"